// The provisional storefront unit price, shown until Epic 11's price read lands
// (Story 11.5, ADO #1956, owns real storefront price display).
//
// The product surfaces show this fixed €9.99 to fill the UI (TL go-ahead, 2026-10-05). Since
// Pricing migration 12 (ADO-2243), while the api's `PRICING_REFERENCE_DATA_ENABLED` is on, order
// capture's `ORDER_CAPTURE_PRICE_PORT` is its `PriceAdapter` over the pricing interface
// (`PRICE_QUOTE_PORT`), so a cart line locks the real price for its cart, and a product surface
// showing this figure can disagree with it; while it is off, the server's stand-in locks this
// same €9.99 default (D8). Cart money never reads this: a
// cart line carries the unit price the server locked on it, so cart totals are server truth.
//
// SWAP POINT: when a product price read exists, replace `provisionalUnitPrice` with it.
// Every product surface reads its price through this one function.

import type { MoneyValue } from '../shared/money';

/** The fixed unit price the product surfaces show (the server stand-in's default, ADO-2243 D8). */
export const PROVISIONAL_UNIT_PRICE: MoneyValue = { amount: 9.99, currency: 'EUR' };

/** The unit price a product surface shows for `skuCode`. Provisional: the same figure
 *  for every SKU until a product price read exists. */
export function provisionalUnitPrice(skuCode: string): MoneyValue {
  void skuCode;
  return PROVISIONAL_UNIT_PRICE;
}
